import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// useResponsive 커스텀 훅
const useResponsive = (breakpoint) => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return { isTablet };
};

function CategoryTab({ categoryNames, mainCategory, activeTitle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const ctgSelectBoxRef = useRef();
  const { isTablet } = useResponsive(1280);
  const [activeValue, setActiveValue] = useState('');

  const handleSelectOpen = () => {
    setActiveValue(prev => (prev ? '' : categoryNames[0].category_name));
  };

  const handleSelectItem = (name, code) => {
    setActiveValue(name);
    
    const queryParams = new URLSearchParams(location.search);
    queryParams.set('sub', code);
    queryParams.set('title', name);
    
    // 현재 페이지의 mainCategory 값을 가져오기
    const currentMainCategory = mainCategory || 
                              new URLSearchParams(location.search).get('mainCategory') || 
                              'CINEMA';
    
    queryParams.set('mainCategory', currentMainCategory);
    
    // 현재 페이지 경로 확인
    const currentPath = location.pathname;
    
    // 만약 현재 경로가 CinemaPage라면 CinemaPageSec로 이동
    if (currentPath.includes('/category/cinemaPage')) {
      // state로 데이터 전달하여 중복 API 호출 방지
      navigate(`/category/cinemaPageSec?${queryParams.toString()}`, {
        state: {
          mainCategories: categoryNames,
          // 추가 데이터 전달
          skipApiCall: true // API 호출 스킵 플래그
        }
      });
    } else {
      // 다른 페이지에서는 현재 경로를 유지하며 쿼리 파라미터만 변경
      navigate({
        pathname: location.pathname,
        search: queryParams.toString()
      });
    }
  };

  const adjustMargin = useCallback(() => {
    const grandparentEl = document.querySelector('.product_banner');
    if (!grandparentEl) return;

    if (ctgSelectBoxRef.current) {
      grandparentEl.style.marginBottom = ctgSelectBoxRef.current.offsetHeight > 63
        ? `${ctgSelectBoxRef.current.offsetHeight - 63}px`
        : '';
    }
  }, []);

  useEffect(() => {
    adjustMargin();
  }, [adjustMargin]);

  useEffect(() => {
    // activeTitle이 제공되면 이를 우선적으로 사용
    if (activeTitle && categoryNames.some(cat => cat.category_name === activeTitle)) {
      setActiveValue(activeTitle);
    } else {
      const queryParams = new URLSearchParams(location.search);
      setActiveValue(queryParams.get('title') || categoryNames[0].category_name);
    }
    adjustMargin();
  }, [location.search, adjustMargin, categoryNames, activeTitle]);

  return (
    <div className='category_tab'>
      {!isTablet && (
        <div ref={ctgSelectBoxRef} className="ctg_select_box">
          {categoryNames.map((category, index) => {
            return (
              <button
                key={index}
                className={`default_btn white ${activeValue === category.category_name ? 'active' : ''}`}
                type="button"
                onClick={() => handleSelectItem(category.category_name, category.category_code)}
              >
                {category.category_name}
              </button>
            );
          })}
        </div>
      )}
      
      {isTablet && (
        <div ref={ctgSelectBoxRef} className={`default_select black ${activeValue ? '' : 'open'}`}>
          <button
            className={`select_btn ${activeValue ? 'active' : ''}`}
            type="button"
            onClick={handleSelectOpen}
          >
            <span className="ellipsis_clamp" style={{fontSize: '15px'}}>
              {activeValue || categoryNames[0].category_name}
            </span>
            <span className='view_more'> VIEW MORE</span>
          </button>
          <ul className="select_list">
            {categoryNames.map((category, index) => {
              return (
                <li
                  key={index}
                  className={`ellipsis1 select_item ${activeValue === category.category_name ? 'active' : ''}`}
                  onClick={() => handleSelectItem(category.category_name, category.category_code)}
                >
                  {category.category_name}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CategoryTab;